import { Check, X, ArrowRight } from "lucide-react";
import { Reveal, SectionHead } from "../components/ui-bits";
import { useApp } from "../context/AppContext";
import { COMPARISON } from "../config/defaults";

export default function Comparison() {
  const { openBooking } = useApp();
  return (
    <section id="compare" className="light-section relative py-20 lg:py-28" data-testid="comparison-section">
      <div className="container-x">
        <SectionHead
          eyebrow="The Difference"
          light
          title={<>Why Settle for the Old Way?</>}
          sub="Car care built around your time."
          align="center"
        />

        <div className="mx-auto mt-14 grid max-w-5xl grid-cols-1 gap-6 md:grid-cols-2">
          <Reveal>
            <div className="h-full rounded-[1.75rem] border border-black/[0.08] bg-white/60 p-7 sm:p-8" data-testid="comparison-traditional">
              <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-mist-2">Traditional car wash</p>
              <ul className="mt-6 flex flex-col gap-4">
                {COMPARISON.traditional.map((t) => (
                  <li key={t} className="flex items-start gap-3 text-sm leading-relaxed text-[#5c5470]">
                    <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-black/[0.06] text-[#8a8399]">
                      <X size={12} />
                    </span>
                    {t}
                  </li>
                ))}
              </ul>
            </div>
          </Reveal>

          <Reveal delay={0.1}>
            <div
              className="relative h-full overflow-hidden rounded-[1.75rem] border border-carza/40 bg-gradient-to-b from-[#f3efff] to-white p-7 shadow-[0_30px_70px_-30px_rgba(109,61,245,0.45)] sm:p-8"
              data-testid="comparison-carza"
            >
              <div className="dot-grid-light pointer-events-none absolute inset-0" />
              <div className="relative">
                <p className="flex items-center gap-2 font-mono text-[10px] uppercase tracking-[0.25em] text-carza">
                  <span className="h-1.5 w-1.5 rounded-full bg-carza" /> The Carza way
                </p>
                <ul className="mt-6 flex flex-col gap-4">
                  {COMPARISON.carza.map((t) => (
                    <li key={t} className="flex items-start gap-3 text-sm font-medium leading-relaxed text-nighttext">
                      <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-carza text-white">
                        <Check size={12} />
                      </span>
                      {t}
                    </li>
                  ))}
                </ul>
                <button onClick={() => openBooking()} className="btn btn-primary mt-8 w-full py-4" data-testid="comparison-cta">
                  Book a Car Care <ArrowRight size={15} />
                </button>
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
